<script>
//import Swiper from 'swiper';

//const Swiper = window.Swiper;

export default {
    props:['products', 'range', 'size'],
    data(){
        return {
            swiper: null,
            screenWidth: 0
        }
    },
    mounted() {
        //console.log('swiper ready!');
        this.$nextTick(()=>{
            this.swiper = new window.Swiper( this.$refs.swiperContainer, {
                speed: 400,
                slidesPerView: 4,
                slidesPerGroup: 4,
                on: {
                    init:()=>{
                        //console.log('swiper initialized');
                        this.screenWidth = window.innerWidth
                    },
                    resize:()=>{
                        this.screenWidth = window.innerWidth
                    },
                },
                //centeredSlides: true,
                coverflow: {
                    rotate: 40,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows : false
                },
                //nextButton: ,
                //prevButton: this.$refs.swiperButtonPrev,
                navigation: {
                    nextEl: this.$refs.swiperButtonNext,
                    prevEl: this.$refs.swiperButtonPrev,
                },
                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    640: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    320: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    }
                }
            })
        });  
    },            
    computed:{
        isCentered(){

            //console.log(this.products.length, this.screenWidth)

            if(this.screenWidth > 768 && this.products.length <= 3 ){
                return true;
            } else if(this.screenWidth > 640 && this.products.length <= 3 ){
                return true;
            } else if(this.screenWidth > 320 && this.products.length <= 1 ){
                return true;
            } else if(this.screenWidth < 320 && this.products.length <= 2 ){
                return true;
            } else {
                return false;
            }

            
        }
    }
}
</script>
